import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class AddBottomBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      name: "",
      pincode: "",
      city: "",
      title: "",
      url: "",
      selectedPackage: "",
      startDate: "",       // Add startDate state
      expiryDate: "",      // Add expiryDate state
      packages: [],
      submissionStatus: null,
      currentImageUrl: null,
      submit: false,
      errors: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
    };
    
  }

  async componentDidMount() {
    try {
      const response = await axios.get("https://samaj.aasmo.in/api/admin/sponsor-packages", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        // Access the packages from the response
        const packages = response?.data?.data; // Adjust according to your actual response structure
        this.setState({ packages });
      }
    } catch (error) {
      console.log("Error fetching packages:", error);
      this.setState({ errors: ["Error fetching packages."] });
    }
  }

  // handleChange = (e) => {
  //   const file = e.target.files[0];
  //   const errors = [];

  //   if (file) {
  //     const img = new Image();
  //     img.src = URL.createObjectURL(file);

  //     img.onload = () => {
  //       const { width, height } = img;
  //       if (file.size > this.state.maxSize) {
  //         errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
  //       } else if (width !== 1500 || height !== 300) {
  //         errors.push(`Image size should be exactly 1500x300 pixels.`);
  //       } else {
  //         this.setState({
  //           image: file,
  //           currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
  //           errors: []
  //         });
  //       }
  //     };

  //     img.onerror = () => {
  //       errors.push("Invalid image file.");
  //       this.setState({ errors });
  //     };
  //   }

  //   this.setState({ errors });
  // };

   handleChange = (e) => {
    const file = e.target.files[0];
    const errors = [];

    if (file) {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
        this.setState({
          image: null, // Clear image if too large
          currentImageUrl: null,
          errors: errors
        });
      } else {
        // If file size is valid, set the image and create URL
        this.setState({
          image: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
          errors: [] // Clear any previous errors
        });
      }
    } else {
      // If no file is selected (e.g., user opens and closes file dialog)
      this.setState({
        image: null,
        currentImageUrl: null,
        errors: []
      });
    }
  };


  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submit: true });
  
    const { image, pincode, city, title, selectedPackage, startDate, expiryDate,url } = this.state;
  
    if (!image || !pincode.trim() || !startDate || !expiryDate) {
      return; 
    }
  
    try {
      const formData = new FormData();
      formData.append('image', image);
      formData.append('pincode', pincode);
      formData.append('city', city);
      formData.append('title', title);
      formData.append('packageId', selectedPackage);
      formData.append('startDate', startDate);
      formData.append('expiryDate', expiryDate);
      formData.append('url', url); 
      const response = await axios.post("https://samaj.aasmo.in/api/admin/sponsor", formData, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
  
      if (response.status === 201) {
        this.setState({ submissionStatus: 'success', submit: false });
        setTimeout(() => {
          this.props.history.push("/sponsor-list");
        }, 2000);
      }
    } catch (error) {
      console.log("Error submitting form:", error);
      this.setState({ submissionStatus: 'error' });
    }
  };
  

  render() {
    const { image, name, pincode, city, title, selectedPackage, packages,url , submit, currentImageUrl, submissionStatus, errors } = this.state;
    const isNameValid = name.trim().length > 0;
    const isPincodeValid = pincode.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Add Sponsor</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                {/* <label>Banner Image (1500x300 pixels)</label> */}
                <label>Banner Image </label>
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!image && submit && "parsley-error"}`}
                  name="image"
                  required
                  onChange={this.handleChange}
                />
                {!image && submit ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
                {errors.length > 0 && (
                  <ul className="parsley-errors-list filled">
                    {errors.map((error, index) => (
                      <li key={index} className="parsley-required">
                        {error}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="form-group">
                <label>Pincode</label>
                <input
                  className={`form-control ${!isPincodeValid && submit && "parsley-error"}`}
                  value={pincode}
                  name="pincode"
                  type="text"
                  required
                  onChange={(e) => {
                    this.setState({ pincode: e.target.value });
                  }}
                />
                {!isPincodeValid && submit ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>City</label>
                <input
                  className="form-control"
                  value={city}
                  name="city"
                  type="text"
                  onChange={(e) => {
                    this.setState({ city: e.target.value });
                  }}
                />
              </div>

              <div className="form-group">
                <label>Title</label>
                <input
                  className="form-control"
                  value={title}
                  name="title"
                  type="text"
                  onChange={(e) => {
                    this.setState({ title: e.target.value });
                  }}
                />
              </div>
              <div className="form-group">
                <label>URL</label>
                <input
                  type="url"
                  className="form-control"
                  value={url}
                  name="url"
                  onChange={(e) => this.setState({ url: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Package</label>
                <select
                  className="form-control"
                  value={selectedPackage}
                  name="package"
                  onChange={(e) => {
                    this.setState({ selectedPackage: e.target.value });
                  }}
                >
                  <option value="">Select a package</option>
                  {packages.map((pkg) => (
                    <option key={pkg._id} value={pkg._id}>
                      {pkg.title} {/* Use the appropriate field from the package */}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
    <label>Start Date</label>
    <input
      type="date"
      className="form-control"
      value={this.state.startDate}
      name="startDate"
      onChange={(e) => this.setState({ startDate: e.target.value })}
      required
    />
  </div>
  <div className="form-group">
    <label>Expiry Date</label>
    <input
      type="date"
      className="form-control"
      value={this.state.expiryDate}
      name="expiryDate"
      onChange={(e) => this.setState({ expiryDate: e.target.value })}
      required
    />
  </div>
              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              {submissionStatus === 'error' && (
                <div className="alert alert-danger" role="alert">
                  An error occurred. Please try again.
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, { notifyGeneralInfo })(AddBottomBanner));
